import React, { useState } from 'react';
import { cn } from '@/lib/utils';
import { SectionNavItem } from './';

export function SectionNavbar({ navItems, tabBarClassName }) {
  const [selectedItem, setSelectedItem] = useState(0);
  const visibleComponent = navItems[selectedItem].component;

  return (
    <div
      className={cn(
        'glass-panel glass-panel-interactive mx-auto w-full max-w-[1440px] overflow-hidden px-3 py-3 sm:px-5 sm:py-5',
        tabBarClassName,
      )}
    >
      <div className="mx-auto mb-5 flex h-[56px] w-full max-w-[720px] flex-nowrap justify-center self-center overflow-hidden rounded-2xl border border-black/[0.08] bg-white/45 leading-[56px] shadow-inner backdrop-blur-sm">
        {navItems.map((navItem, index) => (
          <SectionNavItem
            key={index}
            title={navItem.title}
            index={index}
            isSelected={selectedItem === index}
            handleSelectionChanged={setSelectedItem}
          />
        ))}
      </div>
      <div className="min-w-0">{visibleComponent}</div>
    </div>
  );
}
